import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Icon }from 'antd';

class ModalReopen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
    };
  }

  onSubmit = () => {
    // apro il modale di richiesta conferma azione
    this.openModal();
  }

  onConfirm = () => {
    // chiudo il modale, forse non serve neanche farlo
    this.setState({
      modalIsOpen: false,
    });
    // lancio la chiamata delete al WS
    this.props.openRegistry(this.props.registryInfo.idRegistro);
  }

  openModal = () => {
    this.setState({
      modalIsOpen: true,
    });
  }

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
    });
  }

  render() {
    return (
      <div className="mg10 vmg10 inline-left">
        <Button
          onClick={() => this.onSubmit()}
          type="primary"
          size="large"
          disabled={this.props.disabled}
        >
          <Icon type="unlock" />
          <span className="text-center">Riapri</span>
        </Button>
        <Modal
          title="Riapertura registro"
          visible={this.state.modalIsOpen}
          maskClosable={false}
          onCancel={() => this.closeModal()}
          onOk={() => this.onConfirm()}
          cancelText="Annulla"
          okText="Procedi"
        >
          <p>
            Il registro verrà riaperto per ulteriori modifiche.
            Procedere comunque?
          </p>
        </Modal>
      </div>
    );
  }
}

ModalReopen.propTypes = {
  registryInfo: PropTypes.object.isRequired,
  openRegistry: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ModalReopen;
